<template>
  <router-view />
</template>

<script lang="ts">
import { defineComponent } from "vue";

// Supports weights 100-900
import '@fontsource-variable/noto-sans/wdth.css';
// Supports weights 100-900
import '@fontsource-variable/noto-sans-arabic';

interface AppData {
  interval: number | undefined;
}

export default defineComponent({
  name: "App",
  data(): AppData {
    return {
      interval: undefined
    };
  },
  mounted() {
    this.updateData();
    this.interval = window.setInterval(this.updateData, 30000);
  },
  unmounted() {
    if (this.interval) {
      window.clearInterval(this.interval);
    }
  },
  provide() {
    return {
      svgRepoBaseUrl: import.meta.env.VITE_SVG_REPO_BASE_URL,
      appBaseUrl: import.meta.env.VITE_DESINGER_APP_BASE_URL,
    };
  },
  methods: {
    async updateData() {
      try {
        await Promise.all([
          // No data to fetch in this app yet
        ]);
      } catch (e) {
        console.log("Error during load of data: ", e);
      }
    }
  }
});
</script>
